import { Button, Flex, Form, Input } from "antd";
import { useEffect } from "react";

const CategoryForm = (props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.editData) {
      form.setFieldsValue({
        category: props.editData.category,
      });
    } else {
      form.resetFields();
    }
  }, [props.editData, form]);

  return (
    <Form
      form={form}
      layout="horizontal"
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 18 }}
      style={{ maxWidth: 600 }}
      onFinish={(data) =>
        props.saveData({ ...props.editData, ...data }).then((success) => {
          if (success) {
            form.resetFields();
          }
        })
      }
    >
      <Form.Item
        label="Category"
        name="category"
        rules={[{ required: true, message: "Please input category name!" }]}
      >
        <Input />
      </Form.Item>

      <Flex justify="end">
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Flex>
    </Form>
  );
};

export default CategoryForm;
